import Dashboard from '@/apps/account/provider/Dashboard.vue';
import { requireProvider } from '@/router/guards/authGuards';

const providersDashboardRoutes = [
  {
    path: '/account/providers/dashboard',
    name: 'providers-dashboard',
    component: Dashboard,
    beforeEnter: requireProvider,
  },
];

export default providersDashboardRoutes;
